import { ScheduleItems } from "../ValidationRangeCep/interface";
import { ScheduleItemsContainer } from "./styles";

interface ScheduleItemProps {
  scheduleItem: ScheduleItems[];
  index: number;
}

export const ScheduleItem = ({ scheduleItem, index }: ScheduleItemProps) => {
  return (
    <ScheduleItemsContainer className="schedule-items">
      {scheduleItem.map((items) => (
        <div key={items.id}>
          <p className="schedule-name text-purple">
            Calendário {index}: {items.name}
          </p>

          {items.appointment_types.map((type) => (
            <div key={type.id} className="item">
              <p>Tipo de Agendamento:</p>
              <a href={type.url} key={type.id} target="_blank" rel="noreferrer">
                {type.name}
              </a>
            </div>
          ))}
        </div>
      ))}
    </ScheduleItemsContainer>
  );
};
